import { BaseControl } from "@cloudpivot/form/src/common/controls/base-control";
export class InputControl extends BaseControl {
}
